import Axios from "axios";
import useAuthStore from "../../stores/useAuthStore";

// Builds the two display lines for the CW Browser serial/HTTP pole display
// (COM port or hardware-controller URL, resolved by the Electron host).
export const buildDisplayLines = (PoleDisplayData, type, dueAmount) => {
  if (type === "Quantity update") {
    return [`${PoleDisplayData.name} x${PoleDisplayData.weight}`, `${parseInt(PoleDisplayData.realPrice * PoleDisplayData.weight)}`];
  }
  if (type === "Add item to cart") {
    return [`${PoleDisplayData.name} x${PoleDisplayData.weight}`, `${PoleDisplayData.nettotal}`];
  }
  if (type === "Total to pay") {
    return [`Total ${PoleDisplayData.total}`, `Remaining to Pay ${PoleDisplayData.total}`];
  }
  if (type === "Show due payment") {
    const remaining = dueAmount ? parseInt(PoleDisplayData.total - dueAmount) : "";
    return [`Total ${PoleDisplayData.total}`, `Remaining to Pay ${remaining}`];
  }
  if (type === "Show payment success") {
    return ["Thank you!", "Visit again"];
  }
  return ["", ""];
};

const CWPoleDisplay = (PoleDisplayData, type, dueAmount) => {
  // CW Browser (Electron) exposes a native serial/HTTP pole display bridge —
  // use it directly and skip the legacy hardware-controller Axios call.
  if (window.electronAPI?.hardware?.updateDisplaySmart) {
    const [line1, line2] = buildDisplayLines(PoleDisplayData, type, dueAmount);
    console.log(`[CWPoleDisplay] Electron path — type="${type}" line1="${line1}" line2="${line2}"`);
    window.electronAPI.hardware
      .updateDisplaySmart("auto", line1, line2)
      .then((result) => {
        if (result?.success) {
          console.log(`[CWPoleDisplay] updateDisplaySmart succeeded for type="${type}"`);
        } else {
          console.warn(`[CWPoleDisplay] updateDisplaySmart failed for type="${type}":`, result?.error);
        }
      })
      .catch((err) => console.warn(`[CWPoleDisplay] updateDisplaySmart threw for type="${type}":`, err?.message));
    return;
  }

  let data = "";
  if (type === "Quantity update") {
    data = `
            <line>
                <left>${PoleDisplayData.name}</left>
                <right>x${PoleDisplayData.weight}</right>
            </line>
            <line>
                <left>${PoleDisplayData.realPrice}</left>
                <right>${parseInt(PoleDisplayData.realPrice * PoleDisplayData.weight)}</right>
            </line>`;
  } else if (type === "Add item to cart") {
    data = `
            <line>
                <left>${PoleDisplayData.name}</left>
                <right>x${PoleDisplayData.weight}</right>
            </line>
            <line>
                <left>${PoleDisplayData.realPrice}</left>
                <right></right>
            </line>`;
  } else if (type === "Total to pay" || type === "Show due payment" || type === "Show payment success") {
    data = `
            <line>
                <left>Total</left>
                <right>${PoleDisplayData.total}</right>
            </line>`;
    if (type === "Total to pay") {
      data += `
                <line>
                    <left>Remaining to Pay</left>
                    <right>${PoleDisplayData.total}</right>
                </line>`;
    } else if (type === "Show due payment") {
      data += `
                <line>
                    <left>Remaining to Pay</left>
                    <right>${dueAmount ? parseInt(PoleDisplayData.total - dueAmount) : ""}</right>
                </line>`;
    } else if (type === "Show payment success") {
      data += `
                <line>
                    <left>Thank you!</left>
                    <right>Visit again</right>
                </line>`;
    }
  }

  const tillData = useAuthStore.getState().tillData;
  const printerURL = tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl;
  if (!printerURL) {
    console.warn(`[CWPoleDisplay] No hardwareController.imageUrl configured — skipping (type="${type}")`);
    return;
  }

  let PoleDisplayPayload = `
    <pole_display>
        ${data}
    </pole_display>`;

  Axios.post(`${printerURL}printer`, PoleDisplayPayload, {
    headers: {
      "Content-Type": "text/plain",
    },
    timeout: 3000,
  })
    .then(() => {
      console.log(`[CWPoleDisplay] Axios path succeeded for type="${type}"`);
    })
    .catch((err) => {
      console.warn(`[CWPoleDisplay] Axios path failed for type="${type}":`, err?.message);
    });
};

export default CWPoleDisplay;
